import { activeSkus } from "../entitlements";
/** A Club look's trial runs this long from the moment its player picks it (review 0015 decision 84). */
export const TRIAL_MS = 72 * 60 * 60 * 1000;
/** Looks that belong to Club, by `<kind>.<id>`; every other look is free (ADR 0029, 0030). */
const CLUB = {
    "deck.anime": "deck.anime",
    "deck.obsidian": "deck.obsidian",
    "scene.orman": "scene.orman",
    "scene.uzay": "scene.uzay",
    "scene.neon": "scene.neon",
};
export function lookKey(look) {
    return `${look.kind}.${look.id}`;
}
export function isClub(look) {
    return CLUB[lookKey(look)] !== undefined;
}
/** Every Club look, for the list a player sees. */
export function clubLooks() {
    return Object.keys(CLUB).map((key) => {
        const [kind, id] = key.split(".");
        return { kind, id };
    });
}
/** The single trial row a player can ever have for a look: its id makes a second one impossible. */
export function trialId(look, userId) {
    return `trial:${lookKey(look)}:${userId}`;
}
/**
 * What a player may do with a look at `now` (review 0015): a free look is free; Club opens every
 * Club look; otherwise the trial row decides, and without one a trial is still available. Pure.
 */
export function lookAccess(look, userId, rows, now) {
    if (!isClub(look))
        return { kind: "free" };
    if (activeSkus(rows, now).includes("club"))
        return { kind: "club" };
    const trial = rows.find((row) => row.id === trialId(look, userId));
    if (trial === undefined || trial.expiresAt === null)
        return { kind: "available" };
    return now < trial.expiresAt
        ? { kind: "trial", endsAt: trial.expiresAt }
        : { kind: "ended", endedAt: trial.expiresAt };
}
/** Until when the access lets a table use the look: null for good, undefined for not at all. */
export function accessUntil(access) {
    if (access.kind === "free" || access.kind === "club")
        return null;
    return access.kind === "trial" ? access.endsAt : undefined;
}
/** The row that starts a trial now; the store must not overwrite one that exists (decision 81). */
export function trialEntitlement(look, userId, now) {
    const sku = CLUB[lookKey(look)];
    if (sku === undefined)
        return null;
    return {
        id: trialId(look, userId),
        ownerKind: "user",
        ownerId: userId,
        sku,
        source: "trial",
        status: "active",
        expiresAt: now + TRIAL_MS,
        updatedAt: now,
    };
}
//# sourceMappingURL=access.js.map